import axios from 'axios';

export async function postSlackMessage(text) {
    const data = new FormData();
    data.append('token', process.env.GATSBY_SLACK_BEARER_TOKEN);
    data.append('channel', process.env.GATSBY_SLACK_CHANNEL_ID);
    data.append('text', text);

    try {
        await axios.post('https://slack.com/api/chat.postMessage', data, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
        });

        return { success: true };
    } catch (e) {
        return { error: true };
    }
}
